// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import axios from 'axios'
import './assets/css/bootstrap.min.css'
import './assets/css/style.css'
import './assets/icon/iconfont.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VueBus from 'vue-bus'
import {
  Scrollbar,
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Checkbox,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  Form,
  FormItem,
  Tag,
  Tree,
  Alert,
  Row,
  Col,
  Upload,
  Card,
  Collapse,
  CollapseItem,
  ColorPicker,
  Loading,
  Tabs,
  TabPane,
  InputNumber,
  MessageBox,
  Select,
  Option,
  Tooltip,
  Carousel,
  CarouselItem,
  Popover
} from 'element-ui';
import DonMessage from '@/assets/js/message'
import { initSkin } from './utils/skin'
import 'element-ui/lib/theme-chalk/index.css';
import tableHeight from './assets/js/tableHeight'
Vue.use(tableHeight);
Vue.use(Scrollbar);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Card);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ColorPicker);
Vue.use(Loading.directive);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Option);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.component(MessageBox);
Vue.use(VueBus);
// 引入 ECharts 主模块
let echarts = require('echarts/lib/echarts');
// 引入折线图/柱状图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/toolbox')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')//图例滚动
require('echarts/lib/component/dataZoom')
//vue全局注入echarts
Vue.prototype.$echarts = echarts;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = DonMessage;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

// 权限点判断:读登录时后端下发的权限集,越权请求由接口层 token 鉴权兑底
Vue.prototype.$can = function (perm) {
  try {
    return JSON.parse(localStorage.getItem('pilePerms') || '[]').indexOf(perm) !== -1
  } catch (e) {
    return false
  }
}

//配置全局请求url
// Vue.prototype.$axios = axios.create({
//   baseURL: 'http://localhost:3000'//测试
// })

Vue.config.productionTip = false

//启动即注入皮肤覆盖样式,登录页与业务页按钮/横幅统一皮肤色
initSkin()

NProgress.configure({
  easing: 'ease',  // 动画方式
  speed: 500,  // 递增进度条的速度
  showSpinner: true, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js